import ClientService from '../../../services/client-service';
import getCommentListDataQuery from '../../../graphql/query/get-comment-list-data.graphql';
import readCommentsMutation from '../../../graphql/mutation/read-comments.graphql';
import commentAddedSubscription from '../../../graphql/subscription/comment-added.graphql';

export default class CommentsApi {
  public static getCommentListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getCommentListDataQuery, payload);
  }

  public static readComments(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(readCommentsMutation, payload);
  }

  public static commentAdded(payload: ActionPayload, callback: Function): Promise<ApolloClientSubscription> {
    return ClientService.sendGraphqlSubscriptionRequest(commentAddedSubscription, payload, callback);
  }
}
